/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SiteshootshareconnectcomInputs */

const en_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const es_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const fr_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const de_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const ja_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const zh_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const ar_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const id_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const it_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const ru_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const pt_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

const ko_siteshootshareconnectcom = /** @type {(inputs: SiteshootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site.shootshareconnect.com`)
};

/**
* | output |
* | --- |
* | "site.shootshareconnect.com" |
*
* @param {SiteshootshareconnectcomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const siteshootshareconnectcom = /** @type {((inputs?: SiteshootshareconnectcomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SiteshootshareconnectcomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_siteshootshareconnectcom(inputs)
	if (locale === "es") return es_siteshootshareconnectcom(inputs)
	if (locale === "fr") return fr_siteshootshareconnectcom(inputs)
	if (locale === "de") return de_siteshootshareconnectcom(inputs)
	if (locale === "ja") return ja_siteshootshareconnectcom(inputs)
	if (locale === "zh") return zh_siteshootshareconnectcom(inputs)
	if (locale === "ar") return ar_siteshootshareconnectcom(inputs)
	if (locale === "id") return id_siteshootshareconnectcom(inputs)
	if (locale === "it") return it_siteshootshareconnectcom(inputs)
	if (locale === "ru") return ru_siteshootshareconnectcom(inputs)
	if (locale === "pt") return pt_siteshootshareconnectcom(inputs)
	return ko_siteshootshareconnectcom(inputs)
});